import { Reveal } from "./Reveal";
import { buildWhatsAppLink } from "./WhatsAppButton";
import { useLang } from "../../i18n";

export function LongStay() {
  const { t } = useLang();
  const l = t.longstay;
  return (
    <section id="longs-sejours" className="px-6 pb-28 lg:px-10 lg:pb-36">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <div className="column-accent border border-border bg-secondary/40 p-10 pl-12 sm:p-14 sm:pl-16">
            <p className="text-[10px] uppercase tracking-[0.3em] text-crimson">{l.eyebrow}</p>
            <h2 className="mt-4 font-display text-3xl italic sm:text-4xl">{l.title}</h2>
            <div className="hairline mt-6 w-12" />
            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">{l.text}</p>
            <a
              href={buildWhatsAppLink(l.waMessage)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="longstay-whatsapp-cta"
              className="mt-9 inline-flex items-center border border-foreground px-8 py-4 text-[11px] uppercase tracking-[0.25em] transition hover:bg-foreground hover:text-background"
            >
              {l.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
